const Logo = () => {
    return (
        <div className="mb__logo-container">
            <img src="./img/mb-logo-small.jpg" alt="Monarc Builds" className="mb__logo" />
        </div>
    );
};

export default Logo;